import { langCheck, setThemeAndIframe, setBodyClass, setInsideTab } from "Pub/js/utils.js";
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import { setStore } from "Pub/js/storageUtils";
import { get } from 'lodash';

const getBackgroundObject = ({ bdcolor, bdpicdim, bdpicture, bdtype, backpic }) => {
    return _.merge(_.cloneDeep(subjectDefaultData.defaultBackgroundObject), {
        bgColor: bdcolor,
        blurNumber: bdpicdim,
        bgImg: backpic || bdpicture, // 自定义背景图是backpic
        bdtype,
    });
};

const setStyleSetting = obj => {
    return new Promise(resolve => {
        Ajax({
            url: "/nccloud/workbench/corporatestyle/setcorporatestyle.do",
            data: obj,
            noNeedShowError: true, /*  */
            success: ({ data }) => {
                if (data && data.success) {
                    resolve(data.data);
                }
            },
            error: ({ data }) => {
                Notice({
                    status: "warning",
                    msg: data.error.message,
                });
            },
        });
    });
};

const getRequestWatermark = (watermarkSetting, pk_group, styletype) => {
    let {
        marktype: type,
        marktpl,
        markimg: picture,
        fontfamily,
        fontsize,
        fontcolor,
        fontbold,
        fontitalic,
        ref_openapps = [],
        ref_printapps = [],
        usewatermark,
        ...rest
    } = watermarkSetting;
    // let fontsetting = JSON.stringify([fontfamily, fontsize, fontcolor, fontbold, fontitalic]);
    let fontsetting = JSON.stringify({
        fontFamily: fontfamily,
        fontSize: fontsize,
        color: fontcolor,
        bold: fontbold,
        italic: fontitalic,
    });
    let word = JSON.stringify(marktpl);
    let waterMarkAssignVOs = [];
    if (!watermarkSetting.useallapppage) {
        ref_openapps.forEach(item => {
            waterMarkAssignVOs.push({
                appid: get(item, 'values.appid.value'),
                usetype: 'openapp',
            });
        });
    }
    if (!watermarkSetting.useallprintpage) {
        ref_printapps.forEach(item => {
            waterMarkAssignVOs.push({
                appid: get(item, 'values.appid.value'),
                usetype: 'openprint',
            });
        });
    }
    
    if (type === '1' || !type) {
        picture = '';
    }
    if (type === '2' || !type) {
        word = '[]';
    }
    const postData = {
        waterMarkVO: { ...rest, pk_group, styletype, type, word, picture, fontsetting, usewatermark },
        waterMarkAssignVOs,
    };
    return postData;
}

const setWatermarkSetting = (postData) => {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/workbench/corporatestyle/savewatermark.do',
            data: postData,
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
            },
            success: ({ data }) => {
                if (data && data.success) {
                    resolve(data.data);
                }
            },
            error: ({ data }) => {
                Notice({ status: "error", msg: data.error && data.error.message });
            },
        });
    });
};

const requestStyleSettings = ({ obj, usermodify, changeBgState, currentPkGroup, pk_group }) => {
    // const promiseArr = [
    //     setStyleSetting(obj),
    //     setWatermarkSetting(getRequestWatermark(obj.watermarkSetting, pk_group, obj.styletype)),
    // ];
    const ajaxData = {
        corporatestyle: obj,
        watermark: getRequestWatermark(obj.watermarkSetting, pk_group, obj.styletype)
    };
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/workbench/corporatestyle/savecorpstylewatermark.do',
            data: ajaxData,
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
            },
            success: ({ data }) => {
                if (data && data.success) {
                    Notice({
                        status: "success",
                        msg: langCheck('0000PUB-000427'), /* 国际化处理： 应用成功*/
                    });
                    const styleData = data.data.corporatestyle;
                    const watermarkData = data.data.watermark;
        
                    const { icon, color } = styleData;
                    const { pk_customtheme } = obj;
                    if (currentPkGroup === pk_group) { // 当前集团与所选集团一致才生效
                        if (!usermodify) {
                            // 这里能生效的条件是在企业风格设置-集团
                            // 如果不允许用户修改，那么集团应用了啥风格，当前用户理应直接响应
                            // 反过来想，如果一开始是允许用户修改的，在应用时勾选了不允许修改，那么这里将不会走，就无法直接响应
                            // 总之，原有逻辑有漏洞，无法覆盖各种场景，不如不要处理
                            // 之后有更好的方案再优化
        
                            // let checkedColor = pk_customtheme ? 'mixin' : subjectDefaultData.colorMap[color];
                            // window.nccIcon = icon || "";
                            // const backgroundObject = getBackgroundObject(styleData);
                            // changeBgState(backgroundObject); //修改store里面的背景
                            // setStore("nccIcon", icon || "");
                            // window.nccColor = checkedColor;
                            // setInsideTab(obj.tabstyle);
                            // setStore("nccColor", checkedColor);
                            // // 更换plantform.css
                            // // setTheme.call(this, `nc-lightapp-front-${colorMap[checkedColor]}`);
                            // // 更换body class
                            // setBodyClass({ themeType: checkedColor });
                            // setThemeAndIframe(checkedColor, color);
                        }
                    }

                    resolve([styleData, watermarkData]);
                }
            },
            error: ({ data }) => {
                Notice({ status: "error", msg: data.error && data.error.message });
            },
        });
    });
};

/**
 * 格式化水印设置返回的数据 
 * {
 *      waterMarkVO: {
 *          pk_watermark, // 配置主键
 *          usewatermark, // 是否启用水印
 *          pk_group, // 所属集团
 *          type, // 水印类型 1：文字，2：图片
 *          word, // 水印模版
 *          pickture, // 水印图片
 *          fontsetting, // 字体设置
 *          rotate, // 旋转角度
 *          opacity, // 透明度
 *          density, // 密度
 *          useallapppage, // 打开应用指派全部
 *          useallprintpage, // 打印输出指派全部
 *          
 *          
 *      },
 *      waterMarkAssignVOs: [ // 待定
 *          {
 *              pk_watermark_asign, // 主键
 *              pk_watermark, // 
 *              type, // 指派类型 0：打开应用，1：打印输出
 *          }
 *      ] 
 * }
 */
const getWaterMarkObject = data => {
    const { waterMarkVO = {}, waterMarkAssignRefs = [] } = data;
    const usewatermark = get(waterMarkVO, 'usewatermark', false);
    const marktpl = JSON.parse(get(waterMarkVO, 'word', '[]'));
    const markimg = get(waterMarkVO, 'picture');
    const fontsetting = JSON.parse(get(waterMarkVO, 'fontsetting', '[]'));
    const fontSettingObj = Array.isArray(fontsetting) ? {
        fontfamily: fontsetting[0] || 'Microsoft YaHei',
        fontsize: fontsetting[1] || 12,
        fontcolor: fontsetting[2] || '#111111',
        fontbold: fontsetting[3] || false,
        fontitalic: fontsetting[4] || false,
    } : {
        fontfamily: get(fontsetting, 'fontFamily', 'Microsoft YaHei'),
        fontsize: get(fontsetting, 'fontSize', 12),
        fontcolor: get(fontsetting, 'color', '#111111'),
        fontbold: get(fontsetting, 'bold', false),
        fontitalic: get(fontsetting, 'italic', false),
    };
    const ref_openapps = get(waterMarkAssignRefs, 'openapp', []).map(el => {
        const { refcode, refname, values } = el;
        return { refpk: refcode, refcode, refname, values };
    });
    const ref_printapps = get(waterMarkAssignRefs, 'openprint', []).map(el => {
        const { refcode, refname, values } = el;
        return { refpk: refcode, refcode, refname, values };
    });

    let watermarkSetting = {
        show: false,
        pk_watermark: get(waterMarkVO, 'pk_watermark'),
        pk_group: get(waterMarkVO, 'pk_group'),
        marktype: !usewatermark ? '' : get(waterMarkVO, 'type', '1'),
        rotate: get(waterMarkVO, 'rotate', -22),
        opacity: get(waterMarkVO, 'opacity', 0.3),
        density: get(waterMarkVO, 'density', 0),
        useallapppage: get(waterMarkVO, 'useallapppage', false),
        useallprintpage: get(waterMarkVO, 'useallprintpage', false),
        marktpl,
        markimg,
        ...fontSettingObj,
        ref_openapps,
        ref_printapps,
        usewatermark,

    };
    return { watermarkSetting };

};

export {
    getBackgroundObject,
    requestStyleSettings,
    getWaterMarkObject,
};